import { render } from "./NotFound.vue?vue&type=template&id=44ac6db0"
const script = {}

import exportComponent from "/vercel/path0/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__